import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "cart_big"
};
const _hoisted_2 = {
  class: "goods_list"
};
const _hoisted_3 = {
  class: "goods_txt"
};
const _hoisted_4 = {
  class: "goods_info"
};
const _hoisted_5 = {
  class: "goods_buy"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  const _component_router_link = _resolveComponent("router-link");
  const _component_van_stepper = _resolveComponent("van-stepper");
  const _component_van_checkbox = _resolveComponent("van-checkbox");
  const _component_van_checkbox_group = _resolveComponent("van-checkbox-group");
  const _component_van_submit_bar = _resolveComponent("van-submit-bar");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_nav_bar, {
    title: "我的购物车",
    "left-arrow": "",
    onClickLeft: $setup.goBack,
    fixed: "",
    placeholder: ""
  }, null, 8, ["onClickLeft"]), $setup.isShow ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_checkbox_group, {
    class: "card-goods",
    modelValue: $setup.checkedGoods,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.checkedGoods = $event),
    ref: "checkGoodsGroup"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cartList, item => {
      return _openBlock(), _createBlock(_component_van_checkbox, {
        key: item.id,
        class: "cart_list",
        name: item.id,
        "label-disabled": ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
          class: "goods_img",
          style: _normalizeStyle("background-image: url(" + $setup.goodsList[item.id].img + ");")
        }, [_createVNode(_component_router_link, {
          to: "/goods/show?id=" + item.id
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.goodsList[item.id].name), 1)]),
          _: 2
        }, 1032, ["to"])], 4), _createElementVNode("div", _hoisted_3, [_createElementVNode("dl", _hoisted_4, [_createElementVNode("dt", null, _toDisplayString($setup.goodsList[item.id].name), 1), _createElementVNode("dd", null, "规格：" + _toDisplayString($setup.goodsList[item.id].spec), 1), _createElementVNode("dd", null, "保质期：" + _toDisplayString($setup.goodsList[item.id].quality), 1)]), _createElementVNode("dl", _hoisted_5, [_createElementVNode("dt", null, [_createElementVNode("span", null, "￥" + _toDisplayString($setup.goodsList[item.id].price) + "/" + _toDisplayString($setup.goodsList[item.id].unit), 1)]), _createElementVNode("dd", null, [_createVNode(_component_van_stepper, {
          modelValue: item.count,
          "onUpdate:modelValue": $event => item.count = $event,
          step: $setup.goodsList[item.id].step_no,
          min: "0",
          name: item.id,
          onChange: $setup.editCart,
          onMinus: $event => $setup.delCart(item.id, $setup.goodsList[item.id].less_no),
          "disable-input": ""
        }, null, 8, ["modelValue", "onUpdate:modelValue", "step", "name", "onChange", "onMinus"])])])])])]),
        _: 2
      }, 1032, ["name"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"])])) : _createCommentVNode("", true), _cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "cart_box"
  }, null, -1)), _createVNode(_component_van_submit_bar, {
    price: $setup.totalPrice,
    disabled: !$setup.checkedGoods.length,
    "button-text": $setup.submitBarText,
    onSubmit: $setup.onSubmit
  }, {
    default: _withCtx(() => [_createVNode(_component_van_checkbox, {
      modelValue: $setup.checkedAll,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.checkedAll = $event),
      onChange: $setup.checkAll
    }, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("全选")])),
      _: 1
    }, 8, ["modelValue", "onChange"])]),
    _: 1
  }, 8, ["price", "disabled", "button-text", "onSubmit"])]);
}